import { render, staticRenderFns } from "./CategoryItem.vue?vue&type=template&id=1360c688&"
import script from "./CategoryItem.vue?vue&type=script&lang=js&"
export * from "./CategoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/benutzer/Desktop/401/Phywe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1360c688')) {
      api.createRecord('1360c688', component.options)
    } else {
      api.reload('1360c688', component.options)
    }
    module.hot.accept("./CategoryItem.vue?vue&type=template&id=1360c688&", function () {
      api.rerender('1360c688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/phywe/CategoryItem.vue"
export default component.exports